// extracted by mini-css-extract-plugin
export default {"spinner":"NewMarkdownViewer-module__spinner__cOO7zNC","safe-html-box":"NewMarkdownViewer-module__safe-html-box__doCwx1z"};